import { render, staticRenderFns } from "./create-wage-popup.vue?vue&type=template&id=aef3d144"
import script from "./create-wage-popup.vue?vue&type=script&lang=js"
export * from "./create-wage-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports